import { render, staticRenderFns } from "./BoundCard.vue?vue&type=template&id=5efa3116"
import script from "./BoundCard.vue?vue&type=script&lang=js"
export * from "./BoundCard.vue?vue&type=script&lang=js"
import style0 from "./BoundCard.vue?vue&type=style&index=0&id=5efa3116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports